export default __webpack_public_path__ + "static/alloy-blog-f0e897872c691b8c7ce8e045d3121013.svg";